import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { getOfferForUpdate, updateOffer,
  clearInitialValues, clearUpdatedFiles, clearHideDeleteFileActions } from '../../actions/shop';
import notifier from '../../../_utils/notifier';
import { ARRANGEMENT_TYPE_SLUG } from '../../../config';
import ArrangementsForm from './Forms/ArrangementsForm.jsx';
import LessonsForm from './Forms/LessonsForm.jsx';
import { LoginRequired } from '../../hoc/LoginRequired.jsx';


class ModeratorOffersUpdateForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      offer: null,
      isLoading: true,
      redirect: false,
    };
    this.type =  props.match.params.type;
    this.offerId = props.match.params.id;
    this.listView = `/${props.lang}/my/moderator/${this.type}/`;
  }

  componentDidMount() {
    this.props.getOfferForUpdate(this.type, this.offerId, true)
      .then((response) => {
        this.setState({
          isLoading: false,
          offer: response
        })
      });
  }

  componentWillUnmount() {
    this.props.clearInitialValues();
    this.props.clearUpdatedFiles();
    this.props.clearHideDeleteFileActions();
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to={ this.listView } />
    }
  }

  handleFormSubmit = (formData) => {
    this.props.updateOffer(this.type, this.offerId, formData, true)
      .then(response => {
        if (response.status === 200) {
          notifier.success(gettext('Изменения внесены.'));
          this.setState({ redirect: true });
        } else {
          notifier.alert(gettext('Пожалуйста, исправьте найденые ошибки.'));
        }
      });
  }

  getForm = () => {
    if (this.type === ARRANGEMENT_TYPE_SLUG) return <ArrangementsForm onSubmit={ this.handleFormSubmit }/>
    else return <LessonsForm onSubmit={ this.handleFormSubmit }/>
  }

  render() {
    if (this.state.isLoading) {
      return <div>{ gettext('Загрузка данных') }</div>;
    }
    let form;
    if (!this.state.offer.error){
        form = this.getForm();
    }
    return <div>
      { this.renderRedirect() }
      <h1>{ this.state.offer.name || this.state.offer.error }</h1>
      { form }
    </div>

  }
}

let mapStateToProps = (state) => {
  return {
    lang: state.auth.lang,
  }
};

export default compose(
  connect(mapStateToProps, {
    getOfferForUpdate, updateOffer,
    clearInitialValues, clearUpdatedFiles, clearHideDeleteFileActions
  }),
  LoginRequired
)(ModeratorOffersUpdateForm);
